@if ((measure$ | async); as measure) {
  <div class="container">
    <div>
      <div>{{measure.name}}</div>
      @if (measure.straightMeasure) {
        <div style="font-size: smaller">{{'straight_line_distance' | transloco}}</div>
      }
      @if (measure.areaVolume) {
        <div  style="font-size: smaller">{{'area_and_volume' | transloco}}</div>
      }
    </div>
    @if ((currentUser$ | async); as currentUser) {
      <div  class="icons">
        @if (!measure.show) {
          <mat-icon>visibility_off</mat-icon>
        }
        @if (measure.isShared && currentUser.name == measure.author) {
          <mat-icon>person</mat-icon>
        }
        @if (measure.isShared) {
          <mat-icon>share</mat-icon>
        }
      </div>
    }
  </div>
}
